<script setup>
    import { reactive, computed } from 'vue'
    import { useChannelsStore } from '@/stores/channels'
    import InputFormHorizontal from '@/components/UI/Form/InputFormHorizontal'
    import { executeLogin, initLogin, loadSDK } from '@/composables/useFacebookLogin'
    import FeedbackAlert from '@/components/utils/FeedbackAlert'
    import AlertPrice from '@/views/dash/channels/Pages/AlertPrice'
    import { notify } from '@kyvg/vue3-notification'
    import StoryActiveAutomation from '@/views/dash/channels/Pages/StoryActiveAutomation'
    import Checkbox from 'primevue/checkbox'

    const state = reactive({ textButton: '' })
    const store = useChannelsStore()

    store.channel.name = store.channel?.name || ''
    store.channel.type = 'instagram'
    store.channel.server_type = 'instagram'
    store.channel.user = store.channel?.user || Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15)

    if (!store.channel.more) {
        store.channel.more = {}
    }

    const permitReply = computed({
        get() {
            const value = store.channel?.more?.permit_reply
            return value === true || value === 'true'
        },
        set(value) {
            store.channel.more.permit_reply = value === true
        }
    })

    const isEdit = computed(() => Boolean(store.channel?.id))

    function handlePermitReplyLabelClick() {
        permitReply.value = !permitReply.value
    }

    loadSDK(document, 'script', 'facebook-jssdk')

    const appId = import.meta.env.VITE_INSTAGRAM_ID
    initLogin(appId)

    function checkLoginState() {
        FB.getLoginStatus(function(response) {
            statusChangeCallback(response);
        });
    }

    function statusChangeCallback(response) {
        if (response.status !== 'connected') {
            notify({
                type: 'error',
                title: 'Opps...',
                text: 'Não foi possível realizar o login. Por favor, tente realizar o login no Facebook novamente!',
            })
            return
        }

        console.warn(response)

        state.textButton = 'Login realizado!'
        store.channel.api_token = response.authResponse.accessToken
    }


    state.textButton = (store.channel?.id ? 'Atualizar' : 'Cadastrar') + ' Instagram'

    const scope = [
        'public_profile',
        'business_management',
        'pages_read_engagement',
        'pages_messaging',
        'pages_manage_metadata',
        'instagram_basic',
        'instagram_manage_messages',
    ]

</script>

<template>
    <div class="space-y-4">
        <InputFormHorizontal
            v-model="store.channel.name"
            :init-value="store.channel.name"
            :block-edit="store.loading"
            label="Identificação do canal"
            placeholder="Como você irá localizar o canal pelo sistema?"
            rules="required"
            vertical
        />

        <div
            v-if="isEdit"
            class="flex items-start gap-3 p-4 border border-slate-200 bg-white rounded-lg dark:border-slate-700 dark:bg-slate-800/40"
        >
            <Checkbox
                input-id="permit-reply-instagram"
                v-model="permitReply"
                :binary="true"
                class="mt-0.5 shrink-0"
            />
            <label for="permit-reply-instagram" class="cursor-pointer" @click.prevent="handlePermitReplyLabelClick">
                <p class="text-sm font-medium text-slate-700 dark:text-slate-100">
                    Permite resposta
                </p>
                <p class="text-xs text-slate-500 mt-1 dark:text-slate-300">
                    Permitir mensagens de origens de resposta, como por exemplo, quando o cliente responde um stories
                </p>
            </label>
        </div>
        <button
            class="flex justify-center bg-gradient-to-r from-indigo-500 via-purple-500 to-pink-600 text-white text-sm font-bold py-2 px-4 rounded-full chat_transition"
            :class="{ 'opacity-50 cursor-not-allowed': store.loading || store.channel.name.length === 0 }"
            :disabled="store.loading || store.channel.name.length === 0"
            @click.prevent.stop="executeLogin(checkLoginState, scope)"
        >
            <Unicon
                name="instagram"
                class="h-5 w-5 mr-2"
            />
            Cadastrar Instagram via Facebook
        </button>

        <AlertPrice />

        <StoryActiveAutomation v-if="store.channel?.id && false" />
    </div>
</template>
